// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"bf335b2a","125":"b5bf57eb","354":"69906bd0","647":"af9e94b7","717":"dca154df"}[chunkId] + ".chunk.css";
};